import { CButton, CButtonGroup, CTooltip } from "@coreui/react";
import { useEffect, useState } from "react";
import PermissionRequiredComponent from "../permissions/PermissionRequiredComponent";
import {
  RECEIVED_DOCUMENTS_DESTROY,
  RECEIVED_DOCUMENTS_RETRIEVE,
  RECEIVED_DOCUMENTS_UPDATE,
} from "../../auth/permissions";
import { ReceivedDocument } from "../../models/received-document";

interface ReceivedDocumentCrudActionsProps {
  document: ReceivedDocument;
  onReadClick: (_: ReceivedDocument) => void;
  onUpdateClick: (_: ReceivedDocument) => void;
  onDeleteClick: (_: ReceivedDocument) => void;
}

const ReceivedDocumentCrudActions: React.FC<
  ReceivedDocumentCrudActionsProps
> = ({ document, onReadClick, onUpdateClick, onDeleteClick }) => {
  const [currentDocument, setCurrentDocument] = useState(document);

  useEffect(() => {
    setCurrentDocument(document);
  }, [document]);

  const readButton = (
    <PermissionRequiredComponent permissionName={RECEIVED_DOCUMENTS_RETRIEVE}>
      <CTooltip content="Ver Datos">
        <CButton
          className="text-white"
          color="info"
          onClick={() => onReadClick(currentDocument)}
        >
          <i className="fa fa-eye"></i>
        </CButton>
      </CTooltip>
    </PermissionRequiredComponent>
  );

  const editButton = (
    <PermissionRequiredComponent permissionName={RECEIVED_DOCUMENTS_UPDATE}>
      <CTooltip content="Editar">
        <CButton
          className="text-white"
          color="warning"
          onClick={() => onUpdateClick(currentDocument)}
        >
          <i className="fa fa-pencil"></i>
        </CButton>
      </CTooltip>
    </PermissionRequiredComponent>
  );

  const deleteButton = (
    <PermissionRequiredComponent permissionName={RECEIVED_DOCUMENTS_DESTROY}>
      <CTooltip content="Eliminar">
        <CButton
          className="text-white"
          color="danger"
          onClick={() => onDeleteClick(currentDocument)}
        >
          <i className="fa fa-trash"></i>
        </CButton>
      </CTooltip>
    </PermissionRequiredComponent>
  );

  const shouldShowEditButton = currentDocument.creationType === "manual";

  return (
    <td className="text-center">
      <CButtonGroup>
        {readButton}
        {shouldShowEditButton ? <>{editButton}</> : <></>}
        {deleteButton}
      </CButtonGroup>
    </td>
  );
};

export default ReceivedDocumentCrudActions;
